import React, { useEffect, useState } from "react";
import apiClient from "../axios/axiosInterceptor";

function RolePermissions({ loggedInUser, role, onClose }) {
    const [permissions, setPermissions] = useState([]);

    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const response = await apiClient.get(`/tenants/${loggedInUser.TenantId}/roles/${role.id}/permissions`);
                setPermissions(response.data.list);
            } catch (error) {
                console.error('Error fetching permissions:', error);
            }
        };

        fetchPermissions();
    }, [role]);

    return (
        <div className="modal">
            <div className="modal-content">
                <span className="close" onClick={onClose}>&times;</span>
                <h2>Permissions for {role.name}</h2>
                <table className="app-table">
                    <thead>
                    <tr>
                        <th>Id</th>
                        <th>Name</th>
                    </tr>
                    </thead>
                    <tbody>
                    {permissions.map(permission => (
                        <tr key={permission.id}>
                            <td>{permission.id}</td>
                            <td>{permission.name}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default RolePermissions;
